import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { AuthenticationStore } from './authentication.store';
import { UserLocalStorageService } from './user.local.storage.service';

export function authFactory(http: Http, options: RequestOptions, userLocalStorageService: UserLocalStorageService) {
  return new AuthHttp(new AuthConfig({
// Config options if you want
    noTokenScheme: true,
    tokenName: AuthenticationStore.TOKEN_NAME,
    tokenGetter: (() => userLocalStorageService.getToken()),
    globalHeaders: [
      {'Cache-Control': 'no-cache, no-store, must-revalidate'},
      {'Pragma': 'no-cache'},
      {'Expires': 'Thu, 01 Jan 1970 00:00:00 GMT'},
      {'If-Modified-Since': '0'}
    ],
  }), http, options);
}

// Include this in your ngModule providers
export const authProvider = {
  provide: AuthHttp,
  deps: [ Http, RequestOptions, UserLocalStorageService ],
  useFactory: authFactory
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/services/angular2-jwt.config.ts